import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useEditContext, usePageContext } from '@xingternal/pages-common';
import { Button } from '@xingternal/button';
import * as Types from '@xingternal/pages-graphql-types';

import { NewsCommbox } from '../NewsCommbox';
import styles from './CommboxButton.css';

const CommboxButton = () => {
  const { isEditing } = useEditContext();
  const { pageContext } = usePageContext();
  const { focusType, pageId } = pageContext;
  const feedQueryVars = { id: pageId, limit: 3, filter: Types.PostingPublicationState.Published };
  const canEditLinkPreview = focusType === 'PUBLISHER' && isEditing;
  // eslint-disable-next-line no-unused-vars

  return (
    <>
      <NewsCommbox
        canEditLinkPreview={canEditLinkPreview}
        feedQueryVars={feedQueryVars}
      >
        {(onClick: () => void) => (
          <Button
            variant={'tertiary'}
            size={'small'}
            className={styles.button}
            onClick={() => {
              onClick();
            }}
            data-testid="EP_EDIT_PAGE_COMMBOX_BUTTON"
          >
            <FormattedMessage id={'EP_EDIT_ACTION_POST'} />
          </Button>
        )}
      </NewsCommbox>
    </>
  );
};

export default CommboxButton;
